// extracted by mini-css-extract-plugin
var _1 = "EntityLabelList-moduleEntityLabelList__KRfqw";
var _2 = "EntityLabelList-modulelabel__G5ZCT";
export { _1 as "EntityLabelList", _2 as "label" }
